import { escapeHtml } from './html';
import { dashboardToneClasses } from './dashboard-presentation';
import {
  selectDashboardNextStep,
  selectDashboardWorkQueue,
  type DashboardNextStep,
  type DashboardNextStepAccount,
  type DashboardNextStepInput,
  type DashboardWorkQueueCard,
} from './dashboard-work-queue';

function renderNextStep(step: DashboardNextStep): string {
  return '<div class="card p-5 mb-6 flex flex-col md:flex-row md:items-center gap-4 border ' + dashboardToneClasses(step.tone) + '">' +
    '<div class="w-12 h-12 rounded-2xl bg-surface-0/70 flex items-center justify-center shrink-0"><i class="fas ' + step.icon + '"></i></div>' +
    '<div class="flex-1 min-w-0">' +
      '<div class="text-xs uppercase tracking-[0.22em] text-zinc-500 mb-1">Recommended next work - ' + escapeHtml(step.roleLabel) + '</div>' +
      '<h2 class="text-lg font-semibold text-white">' + escapeHtml(step.title) + '</h2>' +
      '<p class="text-sm text-zinc-400 mt-1">' + escapeHtml(step.body) + '</p>' +
    '</div>' +
    '<a href="' + escapeHtml(step.href) + '" class="btn-primary whitespace-nowrap" data-next-step-action="' + escapeHtml(step.href) + '">' + escapeHtml(step.action) + '</a>' +
  '</div>';
}

function renderWorkQueueCard(card: DashboardWorkQueueCard): string {
  return '<a href="' + escapeHtml(card.href) + '" class="card block p-4 border ' + dashboardToneClasses(card.tone) + ' group" data-dashboard-work-queue-key="' + escapeHtml(card.key) + '">' +
    '<div class="flex items-start gap-3"><div class="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-surface-0/70">' +
      '<i class="fas ' + escapeHtml(card.icon) + ' text-sm"></i></div><div class="min-w-0 flex-1">' +
      '<div class="flex flex-wrap items-center gap-2"><span class="text-[11px] font-semibold uppercase tracking-wide text-zinc-500">' + escapeHtml(card.roleLabel) + '</span>' +
        '<span class="rounded border border-zinc-700 bg-zinc-950/50 px-2 py-0.5 text-[11px] text-zinc-400">' + escapeHtml(card.countLabel) + '</span></div>' +
      '<h3 class="mt-1 text-sm font-semibold text-zinc-100 group-hover:text-white">' + escapeHtml(card.title) + '</h3>' +
      '<p class="mt-1 break-words text-xs leading-5 text-zinc-500">' + escapeHtml(card.body) + '</p>' +
      '<div class="mt-3 inline-flex items-center gap-1.5 text-xs font-medium text-brand-300">' + escapeHtml(card.action) +
        '<i class="fas fa-arrow-right text-[10px]" aria-hidden="true"></i></div>' +
    '</div></div></a>';
}

function renderWorkQueue(cards: readonly DashboardWorkQueueCard[]): string {
  const activeCount = cards.filter((card) => card.key !== 'browse_issues').length;
  const status = activeCount === 1 ? '1 active lane' : `${activeCount} active lanes`;
  return '<section class="mb-6" aria-labelledby="dashboard-work-queue-title">' +
    '<div class="mb-3 flex flex-wrap items-center justify-between gap-2"><h2 id="dashboard-work-queue-title" class="text-sm font-semibold text-zinc-200">' +
      '<i class="fas fa-list-check mr-2 text-brand-400"></i>Work queue</h2><span class="text-xs text-zinc-500">' + escapeHtml(status) + '</span></div>' +
    '<div class="grid gap-3 md:grid-cols-2 xl:grid-cols-3">' + cards.map(renderWorkQueueCard).join('') + '</div></section>';
}

export function renderDashboardNextStep(data: DashboardNextStepInput, account?: DashboardNextStepAccount): void {
  const nextStep = document.getElementById('dashboard-next-step');
  if (nextStep) nextStep.innerHTML = renderNextStep(selectDashboardNextStep(data, account));
  const queue = document.getElementById('dashboard-work-queue');
  if (queue) queue.innerHTML = renderWorkQueue(selectDashboardWorkQueue(data, account));
}
